import Button from "./Button.jsx";

const BulkDeleteModal = (props) => {

    return (
        <div className={"modal fade"} id={props?.modalName ? props.modalName : "bulkdeletemodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
             tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
            <div className={"modal-dialog"}>
                <div className={"modal-content"}>
                    <div className={"modal-header bg-pal"}>
                        <h2 className={"modal-title"} id={"staticBackdropLabel"}>{props?.header}</h2>
                        <button type={"button"} className={"btn-close"} id={props?.closeBtn ? props.closeBtn : "bulkConfirmClose"} data-bs-dismiss={"modal"} aria-label={"Close"} />
                    </div>
                    <div className={"modal-body"}>
                        <h2 className={"mb-3"} style={{textAlign: "left"}} id={props?.modalContent ? props.modalContent+"Header" : "deleteBulkModalContentHeader"}> </h2>
                        <h3 className={"m-3"} style={{textAlign: "left"}} id={props?.modalContent ? props.modalContent : "deleteBulkModalContent"}> </h3>
                    </div>
                    <div className={"modal-footer"}>
                        <button type={"button"} className={"btn btn-secondary"} style={{width: "75px"}} data-bs-dismiss={"modal"}
                                id={props?.cancelBtn ? props.cancelBtn : "bulkCancelDelete"}>No</button>
                        <Button type={"button"} class={"btn btn-primary d-none"} style={{width: "75px"}} disabled={true} spinner={true}
                                text={"Loading"} id={props?.loadBtn ? props.loadBtn : "loadBulkDeleteSubmit"}/>
                        <button type={"button"} className={"btn btn-danger"} style={{width: "75px"}}
                                id={props?.submitBtn ? props.submitBtn : "bulkDeleteSubmit"} onClick={() => props?.deletePerform()}>Yes</button>
                    </div>
                </div>
            </div>
        </div>
    )

};

export default BulkDeleteModal;